<template>
  <v-dialog v-model="dialog" scrollable width="600">
    <v-card>
      <v-toolbar color="primary" dense class="elevation-0" dark>
        <v-toolbar-title>Cập nhật thực đơn ngày {{ date | ddmmyyyy }}</v-toolbar-title>
        <v-spacer />
        <v-btn icon dark @click="cancel">
          <v-icon>close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-tabs v-if="menuCount > 1" v-model="activeTab" grow class="mb-2">
          <v-tab>Thực đơn 1</v-tab>
          <v-tab>Thực đơn 2</v-tab>
        </v-tabs>
        <v-form ref="form">
          <v-tabs-items v-model="activeTab">
            <!-- menu 1 -->
            <v-tab-item eager>
            <v-row class="mt-4">
              <v-col cols="11" class="py-0">
                <AutocompleteDish
                  v-model="menu1MainDish1"
                  clear-icon="mdi-close"
                  label="Món chính 1"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="mainDishFilter"
                />
              </v-col>
              <v-col cols="1"> </v-col>
              <!-- <v-col cols="11" class="py-0">
              <AutocompleteDish
                v-model="menu1MainDish2"
                clear-icon="mdi-close"
                label="Món chính 2"
                outlined
                dense
                required
                class="required"
                :rules="[$rules.required]"
                :filters="mainDishFilter"
              />
            </v-col>
            <v-col cols="1"> </v-col> -->
            </v-row>
            <v-row v-for="index in menu1SideDishNumArray" :key="`menu1-${index}`">
              <v-col cols="11">
                <AutocompleteDish
                  v-model="menu1SideDishes[index]"
                  clear-icon="mdi-close"
                  label="Món phụ"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="sideDishFilter"
                />
              </v-col>
              <v-col cols="1">
                <v-btn v-if="index === 0" disabled icon></v-btn>
                <v-btn v-if="index > 0" style="margin-top: 2px" color="cancel" @click="removeSideDishMenu1(index)" icon
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="text-none mb-4"
              style="letter-spacing: 0.2px !important"
              @click="addSideDishMenu1()"
              text
              ><v-icon class="mr-2 ml-n4">mdi-plus</v-icon>Thêm món phụ
            </v-btn>
            </v-tab-item>

            <!-- menu 2 -->
            <v-tab-item eager v-if="menuCount > 1">
            <v-row class="mt-4">
              <v-col cols="11" class="py-0">
                <AutocompleteDish
                  v-model="menu2MainDish1"
                  clear-icon="mdi-close"
                  label="Món chính 1"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="mainDishFilter"
                />
              </v-col>
              <v-col cols="1"> </v-col>
              <!-- <v-col cols="11" class="py-0">
              <AutocompleteDish
                v-model="menu2MainDish2"
                clear-icon="mdi-close"
                label="Món chính 2"
                outlined
                dense
                required
                class="required"
                :rules="[$rules.required]"
                :filters="mainDishFilter"
              />
            </v-col>
            <v-col cols="1"> </v-col> -->
            </v-row>
            <v-row v-for="index in menu2SideDishNumArray" :key="`menu2-${index}`">
              <v-col cols="11">
                <AutocompleteDish
                  v-model="menu2SideDishes[index]"
                  clear-icon="mdi-close"
                  label="Món phụ"
                  outlined
                  dense
                  required
                  class="required"
                  :rules="[$rules.required]"
                  :filters="sideDishFilter"
                />
              </v-col>
              <v-col cols="1">
                <v-btn v-if="index === 0" disabled icon></v-btn>
                <v-btn v-if="index > 0" style="margin-top: 2px" color="cancel" @click="removeSideDishMenu2(index)" icon
                  ><v-icon>mdi-close</v-icon></v-btn
                >
              </v-col>
            </v-row>
            <v-btn
              color="primary"
              class="text-none mb-4"
              style="letter-spacing: 0.2px !important"
              @click="addSideDishMenu2()"
              text
              ><v-icon class="mr-2 ml-n4">mdi-plus</v-icon>Thêm món phụ
            </v-btn>
            </v-tab-item>
          </v-tabs-items>
        </v-form>
      </v-card-text>
      <v-divider />
      <v-card-actions class="pa-4">
        <v-btn outlined @click="cancel">HUỶ</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="save">LƯU</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
import AutocompleteDish from '@/components/basic/input/AutocompleteDish.vue'
import moment from 'moment'
import { get } from 'lodash'

export default {
  components: {
    AutocompleteDish
  },
  props: {
    state: Boolean,
    // { date, slotId, menuId, menuCount, menu1Main, menu1Side, menu2Main, menu2Side }
    target: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      dialog: false,
      activeTab: 0,
      date: '',
      mainDishFilter: { type: 'main' },
      sideDishFilter: { type: 'side' },
      menu1MainDish1: null,
      // menu1MainDish2: null,
      menu1SideDishes: [],
      menu1SideDishNum: 1,
      menu2MainDish1: null,
      // menu2MainDish2: null,
      menu2SideDishes: [],
      menu2SideDishNum: 1
    }
  },
  computed: {
    menuCount() {
      return get(this.target, 'menuCount', 1)
    },
    menu1SideDishNumArray() {
      return [...Array(this.menu1SideDishNum).keys()]
    },
    menu2SideDishNumArray() {
      return [...Array(this.menu2SideDishNum).keys()]
    }
  },
  methods: {
    ...mapActions('FoodMenu', ['createMenu', 'fetchData', 'updateMenu']),
    addSideDishMenu1() {
      this.menu1SideDishNum++
    },
    removeSideDishMenu1(index) {
      this.menu1SideDishes.splice(index, 1)
      if (this.menu1SideDishNum > 1) this.menu1SideDishNum--
    },
    addSideDishMenu2() {
      this.menu2SideDishNum++
    },
    removeSideDishMenu2(index) {
      this.menu2SideDishes.splice(index, 1)
      if (this.menu2SideDishNum > 1) this.menu2SideDishNum--
    },

    getData() {
      if (!this.target) return
      this.date = this.target.date
      const m1Main = this.target.menu1Main || []
      const m2Main = this.target.menu2Main || []
      const m1Side = this.target.menu1Side || []
      const m2Side = this.target.menu2Side || []
      this.menu1MainDish1 = m1Main[0] || null
      this.menu2MainDish1 = m2Main[0] || null
      this.menu1SideDishes = [...m1Side]
      this.menu2SideDishes = [...m2Side]
      this.menu1SideDishNum = m1Side.length || 1
      this.menu2SideDishNum = m2Side.length || 1
    },
    cancel() {
      this.dialog = false
    },
    async save() {
      if (!this.$refs.form.validate()) return
      this.$loading.active = true
      try {
        const menu1SideDishIds = this.menu1SideDishes.filter(Boolean).map(d => d.id)
        const menu2SideDishIds = this.menu2SideDishes.filter(Boolean).map(d => d.id)
        const dateMoment = moment(this.date)
        const data = {
          date: dateMoment.startOf('day').toISOString(),
          day: dateMoment.day().toString(),
          meal_slot: this.target.slotId,
          firstMainDishes: get(this.menu1MainDish1, 'id') ? [this.menu1MainDish1.id] : null,
          secondMainDishes: get(this.menu2MainDish1, 'id') ? [this.menu2MainDish1.id] : null,
          firstSideDishes: menu1SideDishIds,
          secondSideDishes: menu2SideDishIds
        }

        if (this.target.menuId) {
          await this.updateMenu({ id: this.target.menuId, ...data })
        } else {
          await this.createMenu(data)
        }

        this.dialog = false
        this.$alert.updateSuccess()
        this.$emit('saved')
      } catch (error) {
        console.error(error)
        this.$alert.updateError(error)
      } finally {
        this.$loading.active = false
      }
    }
  },
  watch: {
    state() {
      this.activeTab = 0
      this.getData()
      this.dialog = true
      this.$nextTick(() => this.$refs.form && this.$refs.form.resetValidation())
    }
  }
}
</script>
